const transferFailedReason = {
  INVALID_AGENCY_OR_ACCOUNT_OR_ACCOUNT_VD: {
    message: 'Agência, conta ou dígito verificador da conta inválido.'
  },
  INVALID_AGENCY_VD_OR_ACCOUNT_VD: {
    message: 'Agência ou dígito verificador da agência inválido. Conta ou dígito verificador da conta inválido.'
  },
  AGENCY_NOT_FOUND: {
    message: 'Agência não encontrada.'
  },
  AGENCY_NOT_FOUND_OR_DISABLED: {
    message: 'Agência não encontrada ou desativada.'
  },
  AGENCY_DISABLED: {
    message: 'Agência do recebedor desativada.'
  },
  INVALID_AGENCY_OR_VD: {
    message: 'Agência ou dígito verificador da agência inválido.'
  },
  INVALID_AGENCY_OR_ACCOUNT: {
    message: 'Conta ou agência inválida.'
  },
  INVALID_ACCOUNT_OR_VD: {
    message: 'Conta ou dígito verificador da conta inválido.'
  },
  ACCOUNT_CLOSED: {
    message: 'Conta corrente ou poupança encerrada.'
  },
  CHECKING_ACCOUNT_CLOSED: {
    message: 'Conta corrente da poupança encerrada.'
  },
  ACCOUNT_BLOCKED: {
    message: 'Conta bloqueada.'
  },
  ACCOUNT_NOT_FOUND: {
    message: 'Conta não encontrada.'
  },
  ACCOUNT_NOT_FOUND_OR_CLOSED: {
    message: 'Conta do recebedor não existe ou foi encerrada.'
  },
  INVALID_ACCOUNT_VARIATION: {
    message: 'Variação da conta poupança inválida.'
  },
  INCORRECT_RECIPIENT_DATA: {
    message: 'Dados incorretos do recebedor.'
  },
  REFUNDED_CREDIT_AMOUNT: {
    message: 'Valor de crédito devolvido pelo banco do recebedor.'
  },
  RECEPIENT_ACCOUNT_EXCEEDED_CREDIT_LIMIT: {
    message: 'Conta do recebedor sem limite para crédito.'
  },
  RECEPIENT_ACCOUNT_CREDIT_NOT_ALLOWED: {
    message: 'Crédito para este recebedor não permitido.'
  },
  RECEPIENT_BLOCKED_PAYMENT_NOT_ALLOWED: {
    message: 'Documento informado CPF/CNPJ possuí bloqueio e não pode receber pagamentos.'
  },
  CHECKING_ACCOUNT_NOT_ALLOWED: {
    message: 'Conta corrente não encontrada. Recebedor possui somente conta poupança.'
  },
  TED_REFUNDED: {
    message: 'TED devolvida pelo banco.'
  },
  TED_REFUNDED_DOCUMENT_IS_DIVERGENT: {
    message: 'TED devolvida pelo banco, divergência de CPF/CNPJ.'
  },
  ACCOUNT_WITH_MONTHLY_LIMIT: {
    message: 'Não foi possível realizar o pagamento, conta do recebedor tem limite de saldo mensal.'
  },
  REJECTED_BY_RECEPIENT_BANK: {
    message: 'Rejeitado pelo banco do recebedor.'
  },
  INFORMED_DOCUMENT_IS_DIVERGENT_FROM_ACCOUNT_OWNER: {
    message: 'CPF/CNPJ informado para pagamento diverge com o CPF/CNPJ do titular no Banco.'
  },
  INVALID_ACCOUNT_TYPE_OR_EXTERNAL_PAYMENT_NOT_ALLOWED: {
    message: 'Tipo de conta inválida e/ou que não permite receber transferências/pagamentos de terceiros.'
  },
  DATA_NOT_FOUND_ON_BANK: {
    message: 'Dados informados não encontrados no banco de destino.'
  },
  TRANSACTION_NOT_ALLOWED_AND_AMOUNT_REFUNDED_BY_BANK: {
    message: 'Transação não permitida, valor de crédito devolvido pelo banco do recebedor.'
  },
  TRANSACTION_NOT_ALLOWED_AND_REFUNDED_BY_BANK: {
    message: 'Transação não permitida, valor devolvido pelo banco do recebedor.'
  },
  INSTITUTION_NOT_ENABLED_TO_RECEIVE_PIX: {
    message: 'Instituição não habilitada para receber PIX.'
  },
  TRANSFER_FAILED_AFTER_RETRIES: {
    message: 'Após algumas tentativas, não conseguimos enviar a transferência ao banco de destino.'
  },
  RECEIVER_INSTITUTION_QRCODE_REJECTED: {
    message: 'QR Code rejeitado pela instituição do recebedor.'
  }
};

module.exports = transferFailedReason;
